import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { COMPS } from './comps';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatPaginatorModule} from '@angular/material/paginator';
import { MatSelectCountryModule } from '@angular-material-extensions/select-country';
import { TranslateModule } from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {DigitsOnlyDirective} from '../directives/digits-only.directive';
// import { NgApexchartsModule } from 'ng-apexcharts';
// import { NgApexchartsModule } from 'ng-apexcharts';
// import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';



@NgModule({
  declarations: [...COMPS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatMenuModule,
    MatDialogModule,
    MatListModule,
    MatPaginatorModule,
    MatSelectCountryModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
   
    // NgApexchartsModule,
    TranslateModule.forChild()
  ],
  exports: [
    ...COMPS,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatMenuModule,
    MatDialogModule,
    MatListModule,
    MatPaginatorModule,
    MatSelectCountryModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    TranslateModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TranslateModule.forChild(),
    // NgApexchartsModule,
    // NgMultiSelectDropDownModule.forRoot()
  ]
})
export class SharedModule {}
